import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

@IonicPage()
@Component({
  selector: 'page-index',
  templateUrl: 'index.html',
})
export class IndexPage {

  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

  elegirSeguro(tipo){
    switch (tipo) {
      case 1:
        this.navCtrl.push('DatosPersonalesPage', {tipo: tipo});
        break;
      case 2:
        this.navCtrl.push('DatosPersonalesPage', {tipo: tipo});
        break;
      case 3:
        
        break;
      case 4:
        this.navCtrl.push('DatosPersonalesPage', {tipo: tipo});
        break;
      case 5:
        this.navCtrl.push('DatosPersonalesPage', {tipo: tipo});
        break;
      case 6:
        this.navCtrl.push('DatosPersonalesPage', {tipo: tipo});
        break;
      case 8:
        this.navCtrl.push('DatosPersonalesPage', {tipo: tipo});
        break;
    }
    
  }

}



// WEBPACK FOOTER //
// ./src/pages/index/index.ts